import React, { ReactNode, FC, useState, useEffect, useRef } from "react";
import closeIcon from "../../dashboard/assets/dashboardCloseIcon.png";
import learningIcon from "../../learning_room/assets/images/video_pending.png";
import "../styles/LearningContentPendingstyles.css";
import PlayIcon from "../../dashboard/assets/playImg.png";
import FileIcon from "../../dashboard/assets/fileIcon.png";
import { useApi } from "../../../service/ApiContext";
import Loader, { LocalStorage } from "../../../utils/Utils";
import Logger from "../../../utils/Logger";
import { useNavigate } from "react-router-dom";
import strings from "../../../utils/Strings";

import { useDispatch, useSelector } from "react-redux";
import NoVideosImg from "../../dashboard/assets/pdfandvideoillustrator.png";

import AllVideosWatchedImg from "../../dashboard/assets/pdfandvideoallwatchedimg.png";

import { TopicVideoResponse } from "../data/response/Topic_Videos_Response";
import { LabSessionVideoResponse } from "../data/response/Lab_Session_Response";
import RecommendationIndustryViewClient from "../data/api_client/LearningRoom_View_Client";
import { useAlert } from "../../../components/AlertContextComponent";
import {
  SubscriptionResponse,
  VideoResponse,
} from "../../dashboard/data/interface/PendingItemsInteface";
import { AssessmentQuestionModuleClient } from "../../dashboard/data/client/VideoReportClient";

import { RootState } from "../../../store/store";
import TruncatedTextWithTooltip from "../../dashboard/components/TruncatedTooltip";
import ShimmerLoader from "../../dashboard/components/ShimmerLoader";
interface BottomOverlayProps {
  isOpen: boolean;
  onClose: () => void;
  //   children: ReactNode;
  cardWidth?: any;
  cardHeight?: any;
  program_id: string | undefined;
}
interface PendingItem {
  id: string;
  topic_id?: string;
  course_id?: string;
  program_id?: string;
  type: "video" | "assessment";
  title: string;
  action: string;
  status?: "active" | "missed";
  assessment_entity_id?: string;
  assessment_id?: string | null;
  current_counter?: number | null;
  time_spend?: number | null;
  total_question?: number | null;
  assessment_duration?: number | null;
  candidate_assessment_status?: string | null;
  program_category?: "Jozuna" | "Industry";
  is_lab_session?: boolean;
  image?: string;
  assessment_expiry?: string;
  // content_type?: string;
  // program_name?: string;
  // course_name?: string;
  // topic_name?: string;
  assessment_start_time?: string;
  file_title?: string;
  assessment_entity_name?: string;
  dimension_questions?: boolean;
  category_questions?: boolean;
  curriculum_questions?: boolean;
  assessment_entity_time_left?: string;
  category_list?: any[];
  curriculum_list?: any[];
}

interface OverallProgressProps {
  program_id: string | undefined;
  //   overallprogressvalue: any;
  //   isAssessment: boolean;
  //   isFromLearningRoom?: boolean;
}

const LRVideoListPendingItems: React.FC<OverallProgressProps> = ({
  program_id,
  //   overallprogressvalue,
  //   isAssessment,
  //   isFromLearningRoom,
}) => {
  const [activeTab, setActiveTab] = useState<"active" | "missed" | "">(
    "active",
  );
  const [videos, setVideos] = useState<any[]>([]);
  const [assessmentsActive, setAssessmentsActive] = useState<any[]>([]);
  const [assessmentsMissed, setAssessmentsMissed] = useState<any[]>([]);

  const [loading, setLoading] = useState(true);
  const [loadingActive, setLoadingActive] = useState(true);

  const [loadingClosed, setLoadingClosed] = useState(true);

  const [videoData, setVideoData] = useState<TopicVideoResponse>();
  const [recommendationVideoData, setRecommendationVideoData] =
    useState<TopicVideoResponse>();

  const api = useApi();
  const navigate = useNavigate();
  const [pendingItems, setPendingItems] = useState<PendingItem[]>([]);
  const [pendingActiveItems, setPendingActiveItems] = useState<PendingItem[]>(
    [],
  );
  const [pendingMissedItems, setPendingMissedItems] = useState<PendingItem[]>(
    [],
  );

  const [pageNumberVideo, setPageNumberVideo] = useState(1);
  const [pageNumberActive, setPageNumberActive] = useState(1);
  const [pageNumberMissed, setPageNumberMissed] = useState(1);

  const [hasMoreVideo, setHasMoreVideo] = useState(true);
  const [hasMoreActive, setHasMoreActive] = useState(true);
  const [hasMoreMissed, setHasMoreMissed] = useState(true);
  const [isIndependent, setIsIndependentuse] = useState<any>();
  const limit = 4;
  const [totals, setTotals] = useState({
    videos: 0,
    active: 0,
    missed: 0,
  });

  const getPendingItemsVideos = async (page: number) => {
    if (program_id === undefined) {
      return;
    }
    // Loader.showLoading("Loading...");
    setLoading(true);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      setLoadingMissed(true);

      const response = await api.get<VideoResponse>(
        `/candidate/pending_items?item=Videos&page_number=${page}&limit=${limit}&program_id=${program_id}`,
      );

      const { no_of_records, records } = response.data;

      // Build video items

      const videoItems: PendingItem[] = records.map((item: any) => {
        const isVideo =
          item.content_type === "video" ||
          (!item.content_type && !!item.video_title);

        const isPdf =
          item.content_type === "pdf" ||
          (!item.content_type && !item.video_title && !!item.file_title);

        return {
          id: item.video_id || Math.random().toString(),
          topic_id: item.topic_id,
          course_id: item.course_id,
          program_id: item.program_id,
          program_category: item.program_category,
          image: isVideo ? PlayIcon : FileIcon,
          // keep compatible with PendingItem type
          type: isVideo ? "video" : "assessment", // or existing non-video type

          title: isVideo
            ? item.video_title || "Untitled Video"
            : item.file_title || "Untitled File",

          action:
            item.completion_status === "In Progress"
              ? "Resume"
              : isVideo
                ? "Watch"
                : "Read",

          is_lab_session: item.is_lab_session,
        };
      });

      setPendingItems((prev) => [...prev, ...videoItems]);

      // Pagination stop condition
      if (page * limit >= no_of_records) {
        setHasMoreVideo(false);
      }
    } catch (error) {
      Logger.info("error response", error);
      setHasMoreVideo(false);
    } finally {
      Loader.dismissLoading();
      setLoadingMissed(false);

      setLoading(false);
    }
  };

  useEffect(() => {
    if (hasMoreVideo) {
      getPendingItemsVideos(pageNumberVideo);
    }
  }, [pageNumberVideo]);

  const [labData, setLabData] = useState<LabSessionVideoResponse>();

  const getLabTopicVideos = async (
    courseId?: string,
    video_id?: string,
    topic_id?: string,
    program_id?: string,
  ) => {
    Loader.showLoading(strings.loading);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    try {
      const response = await api.get<LabSessionVideoResponse>(
        `${RecommendationIndustryViewClient.labSession}?course_id=${courseId}`,
      );
      setLabData(response.data);
      navigate("/dashboard/learning-room/view-labsession/video", {
        state: {
          video_id: video_id, // For initial video to play
          topic_id: topic_id, // Videos topic id
          video_list: response.data.videos[0].list_videos, // labData for video thumbnail & video id
          course_name: null, // Course name
          course_id: courseId, // Course ID
          // course_topic: selectedItem?.topic_title, // Videos topic title
          program_id: program_id,
          program_category: "Industry",
          labSession: true, // Indicates it's a lab session
        },
      });
      // labSetSelectedItem(response.data)
    } catch (error) {
      Logger.error("Error fetching Lab Topic Videos:", error);
    } finally {
      Loader.dismissLoading();
    }
  };
  const getProgram = async (programId?: string) => {
    Loader.showLoading("Loading...");
    setLoading(true);

    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    const param = {
      program_category: "Industry",
    };

    try {
      const response = await api.get<any>("/list_program", param);

      const options = response.data.programs.map((program: any) => ({
        id: program.program_id,
        title: program.program_title,
        description: program.program_description,
      }));

      // Find the matched program using programId
      const matchedProgram = programId
        ? options.find((program: any) => program.id === programId)
        : null;

      if (matchedProgram) {
        return matchedProgram.title;
      }
    } catch (error) {
      Logger.info("error response", error);
    } finally {
      Loader.dismissLoading();
      setLoading(false);
    }

    return null;
  };
  const getTopicVideos = async (
    topicId?: string,
    course_id?: string,
    program_id?: string,
    video_id?: string,
  ) => {
    const programTitle = await getProgram(program_id);

    Loader.showLoading(strings.loading);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      const response = await api.get<TopicVideoResponse>(
        RecommendationIndustryViewClient.getCourseVideoUrl,
        {
          course_id: course_id,
          topic_id: topicId,
          program_id: program_id,
          program_category: "Industry",
        },
      );
      setVideoData(response.data);
      const matchedVideo = response.data?.videos?.[0]?.list_videos?.find(
        (video: any) => video.video_id === video_id,
      );

      navigate("/dashboard/learning-room/view-courses/video", {
        state: {
          video_id: video_id, // For initial video to play
          topic_id: topicId, // Videos topic id
          video_list: response.data?.videos[0].list_videos, // videoData videos
          course_name: null, // Course name
          course_id: course_id, // Course ID
          // course_topic: selectedItem?.topic_title, // Videos topic title
          program_id: program_id,
          program_category: "Industry",
          labSession: false, // Indicates it's not a lab session
          //state Header values
          selectedProgramTitle: programTitle,
          selectedTopicTitle: matchedVideo?.topic_title,
        },
      });

      // setVideoduration(response.data.total_duration);
    } catch (error) {
      Logger.error("Error fetching Course Videos:", error);
    } finally {
      Loader.dismissLoading();
    }
  };

  const getRecommendationTopicVideos = async (
    topicId?: string,
    course_id?: string,
    program_id?: string,
    video_id?: string,
  ) => {
    Loader.showLoading(strings.loading);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      const response = await api.get<TopicVideoResponse>(
        RecommendationIndustryViewClient.getCourseVideoUrl,
        {
          course_id: course_id,
          topic_id: topicId,
          program_id: program_id,
          program_category: "Jozuna",
        },
      );
      setRecommendationVideoData(response.data);
      navigate("/dashboard/recommendation/jozunaview/video", {
        state: {
          video_id: video_id, // For initial video to play
          topic_id: topicId, // Videos topic id
          video_list: response.data?.videos[0].list_videos, // videoData videos
          course_name: null, // Course name
          course_id: course_id, // Course ID
          // course_topic: selectedItem?.topic_title, // Videos topic title
          program_id: program_id,
          program_category: "Jozuna",
          labSession: false, // Indicates it's not a lab session
        },
      });
      // setVideoduration(response.data.total_duration);
    } catch (error) {
      Logger.error("Error fetching Course Videos:", error);
    } finally {
      Loader.dismissLoading();
    }
  };

  const hasVideos = pendingItems.length > 0;
  const { showAlert } = useAlert();
  const hasActiveAssessments = pendingActiveItems.length > 0;
  const hasMissedAssessments = pendingMissedItems.length > 0;

  const dispatch = useDispatch();
  const containerRef = useRef<HTMLDivElement>(null);
  const containerActiveRef = useRef<HTMLDivElement>(null);
  const containerVideoRef = useRef<HTMLDivElement>(null);

  const [loadingMissed, setLoadingMissed] = useState(false);

  const handleScroll = () => {
    if (!containerRef.current) return;

    const { scrollTop, clientHeight, scrollHeight } = containerRef.current;

    if (scrollTop + clientHeight >= scrollHeight - 5) {
      setPageNumberMissed((prev) => {
        const nextPage = prev + 1;
        Logger.info("Page number incremented to", nextPage);
        return nextPage;
      });
      setLoadingMissed(true); // lock until API finishes
    }
  };

  const handleAciveScroll = () => {
    if (!containerActiveRef.current) {
      Logger.info("pagenumber increament%%%% ", pageNumberActive);

      return;
    }

    const { scrollTop, clientHeight, scrollHeight } =
      containerActiveRef.current;

    // Check if near bottom
    if (scrollTop + clientHeight >= scrollHeight - 5) {
      setPageNumberActive((prev) => prev + 1);
      Logger.info("pagenumber increament ", pageNumberActive);
    }
  };
  const handleVideoScroll = () => {
    if (!containerVideoRef.current) {
      Logger.info("pagenumber increament%%%% ", pageNumberVideo);

      return;
    }

    const { scrollTop, clientHeight, scrollHeight } = containerVideoRef.current;

    // Check if near bottom
    if (scrollTop + clientHeight >= scrollHeight - 5) {
      setPageNumberVideo((prev) => prev + 1);
      Logger.info("pagenumber increament ", pageNumberVideo);
    }
  };
  //Subscription check api
  const checkSubscriptionValidation = async (): Promise<boolean> => {
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    Loader.showLoading("Loading...");
    try {
      const response = await api.get<SubscriptionResponse>(
        AssessmentQuestionModuleClient.check_subscription,
      );

      const data = response.data;

      if (data.error) {
        showAlert({
          show: true,
          title: "Error",
          message: data.error,
          alertType: "error",
          onlyNeedOneButton: true,
          button1Text: "Cancel",
          btn1onPressed() {},
        });
        return true;
      }

      return false;
    } catch (error) {
      Logger.error("Error fetching assessment status:", error);
      return false;
    } finally {
      Loader.dismissLoading();
    }
  };

  const profileData = useSelector(
    (state: RootState) => state.profile.profileKeys,
  );
  return (
    <div className="lr-OverallProgressListPending-container">
      {/* Videos Section */}
      {profileData.partner_institute === true && (
        <div
          className="lr-OverallProgressListPending-section"
          // style={{ backgroundColor: "#DFF2FF" }}
        >
          <div className="lr-OverallVideoWatchHeader-section">
            {/* <div className="OverallVideoWatchImg-section">
              <img
                className="OverallVideoWatchImg"
                src={OverallVideoWatch}
                alt="Video icon"
              />
            </div> */}
          </div>

          <div
            style={{
              height: "2px",
              marginTop: "-30px",
              background: "#EAEAEA",
              // margin: "12px 0",
              width: "100%",
              marginBottom: "10px",
            }}
          />

          {hasVideos ? (
            <div className="lr-OverallProgressListPending-itemsList-container">
              <div className="learning-content-banner">
                {/* <div className="banner-icon"> */}
                <img
                  className="banner-icon"
                  src={learningIcon}
                  alt="Learning Content"
                />
                {/* </div> */}

                <div className="banner-content">
                  <p>Conquer the Learning Content</p>
                  <p className="banner-content-sub">
                    Aim for 100% completion on a module this week.
                  </p>
                </div>
              </div>

              <div
                className="lr-OverallProgressListPending-itemsList"
                ref={containerVideoRef}
                style={{
                  maxHeight: "210px",
                  // backgroundColor: "blue",
                  overflowY: "auto",
                  scrollbarWidth: "thin",
                }}
                onScroll={handleVideoScroll}
              >
                {pendingItems.map((item) => (
                  <div
                    key={item.id}
                    className="lr-OverallProgressListPending-item"
                    style={{ backgroundColor: "#FFFFFF" }}
                  >
                    <div className="lr-OverallProgressListPending-titleWrapper">
                      <img
                        src={item.image}
                        alt="content icon"
                        className="lr-OverallProgressListPending-titleIcon"
                        style={{ marginRight: "5px" }}
                      />

                      <TruncatedTextWithTooltip
                        className="lr-OverallProgressListPending-itemTitle"
                        text={item.title}
                      />
                    </div>

                    <button
                      className={`lr-OverallProgressListPending-actionButton ${
                        item.action === "Resume"
                          ? "lr-OverallProgressListPending-resumeButton"
                          : ""
                      }`}
                      onClick={async () => {
                        if (item.program_category === "Industry") {
                          if (item.is_lab_session === true) {
                            await getLabTopicVideos(
                              item.course_id,
                              item.id,
                              item.topic_id,
                              item.program_id,
                            );
                          } else {
                            await getTopicVideos(
                              item.topic_id,
                              item.course_id,
                              item.program_id,
                              item.id,
                            );
                          }
                        } else if (item.program_category === "Jozuna") {
                          await getRecommendationTopicVideos(
                            item.topic_id,
                            item.course_id,
                            item.program_id,
                            item.id,
                          );
                        } else {
                          await getTopicVideos(
                            item.topic_id,
                            item.course_id,
                            item.program_id,
                            item.id,
                          );
                        }
                      }}
                    >
                      {item.action}
                    </button>
                  </div>
                ))}
                {loading && (
                  <>
                    <ShimmerLoader />
                    <ShimmerLoader />
                    <ShimmerLoader />
                  </>
                )}
              </div>
            </div>
          ) : (
            //   overallprogressvalue !== 100 ? (
            //     <div className="Overall-empty-state-container">
            //       <img src={NoVideosImg} className="Overall-empty-state-img"></img>
            //       <div className="Overall-empty-state">
            //         No Learning contents to complete
            //       </div>
            //     </div>
            //   ) :
            <div className="lr-Overall-empty-state-container">
              <img
                src={AllVideosWatchedImg}
                className="lr-Overall-empty-state-img"
              ></img>
              <div className="lr-Overall-empty-state">
                Hooray! You have completed all the learning contents{" "}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const LearningContentPendingList: FC<BottomOverlayProps> = ({
  isOpen,
  onClose,
  cardWidth,
  cardHeight,
  program_id,
}) => {
  if (!isOpen) return null;

  return (
    <div className="dashboarCardoverlayv2" onClick={onClose}>
      <div
        className="dashboarCardoverlay-contentv2"
        style={{ maxWidth: cardWidth, minHeight: cardHeight }}
        onClick={(e) => e.stopPropagation()} // Prevent close when clicking inside
      >
        <div className="dashboarCardoverlay-contentv2body">
          <div className="lr-OverallProgressListPending-sectionTitle">
            Up Next
          </div>
          {/* <button className="dashboardoverlayclose-btn" onClick={onClose}>✕</button> */}
          <img
            className="dashboarCardoverlayClose-btnv2"
            src={closeIcon}
            onClick={onClose}
          />
        </div>
        <LRVideoListPendingItems program_id={program_id} />
        {/* {children} */}
      </div>
    </div>
  );
};

export default LearningContentPendingList;
